import { render, staticRenderFns } from "./companiesCollected.vue?vue&type=template&id=1bcd981a&scoped=true&"
import script from "./companiesCollected.vue?vue&type=script&lang=js&"
export * from "./companiesCollected.vue?vue&type=script&lang=js&"
import style0 from "./companiesCollected.vue?vue&type=style&index=0&id=1bcd981a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd981a",
  null
  
)

export default component.exports